import { render, staticRenderFns } from "./EditEmail.vue?vue&type=template&id=0af5b11a&scoped=true&"
import script from "./EditEmail.vue?vue&type=script&lang=js&"
export * from "./EditEmail.vue?vue&type=script&lang=js&"
import style0 from "./EditEmail.vue?vue&type=style&index=0&id=0af5b11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af5b11a",
  null
  
)

export default component.exports